module.exports = __webpack_public_path__ + "static/media/intro-new1.13d84da4.jpg";